import React, { useEffect } from "react";
import FormDialog from "../../helpers/FormDialog";

export const DiasporaDetailsEdit = ({
    onSuccess,
    setOpen,
    open,
    resourceId,
    setValue0,
    value,
}) => {

    return (
        <FormDialog
            maxWidth={"md"}
            open={open > 0}
            onSuccess={onSuccess}
            setOpen={setOpen}
            url={open === 1 ? "/api/resource/diaspora-info/create" : `/api/resource/diaspora-info/update/${resourceId}`}
            title={open === 1 ? "Add Diaspora Details" : "Update Diaspora Details"}
            fields={[
                {
                    name: "livedAbroad",
                    label: "Have you and/or your parents ever lived outside Rwanda?",
                    type: "radio",
                    values: [
                        { label: "Yes", value: 1 },
                        { label: "No", value: 0 },
                    ],
                    value: value["livedAbroad"],
                    setValue: (val) => {
                        setValue0("livedAbroad", val);
                    },
                    required: true,
                },
                ...(value["livedAbroad"] == 1
                    ? [
                        {
                            name: "isParent",
                            label: "Is it you or your parents?",
                            type: "radio",
                            values: [
                                { label: "You", value: 0 },
                                { label: "Your Parents", value: 1 },
                            ],
                            value: value["isParent"],
                            setValue: (val) => {
                                setValue0("isParent", val);
                            },
                            showIf: (values) => values?.livedAbroad === 1,
                        },
                        {
                            name: "country",
                            label: "Which country?",
                            type: "text",
                            value: value["country"],
                            setValue: (val) => setValue0("country", val),
                            showIf: (values) => values?.livedAbroad === 1,
                        },
                        {
                            name: "address",
                            label: "Country Address",
                            type: "text",
                            value: value["address"],
                            setValue: (val) => setValue0("address", val),
                            showIf: (values) => values?.livedAbroad === 1,
                        },
                    ]
                    : []),
            ]}
        />
    );
};